var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.499,
    height: 101.165,
    fill: "#e9f2f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-310 -5305.97)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(310 5305.97)",
    fill: "#963839"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.751 5350.941)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.688,43.021H85.073L60.469.405a.811.811,0,0,0-1.4,0l-24.6,42.616H27.031V40.772h.7a.811.811,0,0,0,.633-1.318l-7.047-12.2a.81.81,0,0,0-1.4,0l-7.1,12.306a.81.81,0,0,0,.7,1.216h.693v2.249H.81a.811.811,0,0,0-.81.811V69.007a.811.811,0,0,0,.81.811h3.06V95.249H1.417a.81.81,0,0,0-.81.81v4.295a.81.81,0,0,0,.81.81H88.081a.811.811,0,0,0,.81-.811V96.059a.81.81,0,0,0-.81-.81H85.627V69.818h3.061a.811.811,0,0,0,.81-.811V43.832a.811.811,0,0,0-.81-.811M59.767,2.431l23.44,40.6H81.775a.811.811,0,0,0-.81.811V55.609H38.57V43.841a.811.811,0,0,0-.81-.811h-.425v-.009h-1Zm21.2,58.421H38.57V57.23H80.964ZM38.57,62.473H80.964V95.248H38.57Zm-17.95-33.2,4.79,8.3V49.541H15.829V37.573Zm-19,15.365H14.208v5.709a.811.811,0,0,0,.811.81h11.2a.811.811,0,0,0,.81-.81V44.642h7.823c.024,0,.046.009.07.009h2.025V68.2H1.621ZM5.492,69.818H36.949V95.249H32.721V74.963a.811.811,0,0,0-.811-.811H21.788a.811.811,0,0,0-.81.811V95.249H5.492ZM31.1,95.249H22.6V75.774h8.5Zm56.171,4.295H2.228V96.87h35.44a.734.734,0,0,0,.092.009H81.775a.718.718,0,0,0,.092-.009h5.4Zm-3.264-4.295H82.585V69.818h1.422ZM87.877,68.2H82.585V44.652h2.025a.836.836,0,0,0,.139-.018v.009h3.128Z",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.833,88.478H41.46a.81.81,0,0,0,.81-.81V78.335a.81.81,0,0,0-.81-.81H36.833a.811.811,0,0,0-.811.81v9.332a.811.811,0,0,0,.811.81m.81-9.332h3.005v7.711H37.643Z",
    transform: "translate(-18.521 -39.86)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.086,63.846h9.789a.81.81,0,0,0,.81-.81V44.111a.811.811,0,0,0-.81-.81h-9.789a.811.811,0,0,0-.81.81V63.036a.81.81,0,0,0,.81.81m.811-9.462h8.167v7.841H112.9Zm8.167-1.621H112.9V44.922h8.167Z",
    transform: "translate(-57.214 -22.264)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.082,152.627H87.27a.811.811,0,0,0-.81.811v17.434a.811.811,0,0,0,.81.811h5.812a.811.811,0,0,0,.81-.811V153.438a.811.811,0,0,0-.81-.811m-.81,8.718H88.081v-7.1h4.191Zm-4.191,1.621h4.191v7.1H88.081Z",
    transform: "translate(-44.454 -78.475)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,152.627h-5.812a.811.811,0,0,0-.81.811v17.434a.811.811,0,0,0,.81.811H150.9a.811.811,0,0,0,.81-.811V153.438a.811.811,0,0,0-.81-.811m-.81,8.718H145.9v-7.1h4.191Zm-4.191,1.621h4.191v7.1H145.9Z",
    transform: "translate(-74.182 -78.475)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.8,152.627H109.517a.811.811,0,0,0-.81.811v17.434a.811.811,0,0,0,.81.811H121.8a.811.811,0,0,0,.81-.811V153.438a.811.811,0,0,0-.81-.811m-.81,8.718H110.328v-7.1h10.664Zm-10.664,1.621h10.664v7.1H110.328Z",
    transform: "translate(-55.893 -78.475)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.122,152.627H19.31a.811.811,0,0,0-.81.811v12.036a.81.81,0,0,0,.81.81h5.812a.811.811,0,0,0,.811-.81V153.438a.811.811,0,0,0-.811-.811m-.81,6.018H20.121v-4.4h4.191Zm-4.191,1.621h4.191v4.4H20.121Z",
    transform: "translate(-9.512 -78.475)",
    fill: "#e9f2f0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountainIcon);
export default __webpack_public_path__ + "static/media/MountainIcon.589b1ae0638bbb5da1a7ca03eb72b5c2.svg";
export { ForwardRef as ReactComponent };